module.exports = __webpack_public_path__ + "static/src/content/silks/alizee.60dcfd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/alizee.png
// module id = KLSt
// module chunks = 0